"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyInternationalAddressModal = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var format_street_address_1 = require("../../lib/format-street-address");
var selectable_address_1 = require("../selectable-address");
function VerifyInternationalAddressModal(_a) {
    var isOpen = _a.isOpen, handleClose = _a.handleClose, enteredAddress = _a.enteredAddress, candidates = _a.candidates, onSelectAddress = _a.onSelectAddress, width = _a.width;
    var _b = react_1.useState(), selectedCandidate = _b[0], setSelectedCandidate = _b[1];
    var _c = react_1.useState(false), selectEnteredAddress = _c[0], setSelectedAddress = _c[1];
    // if there's no candidates, preselect the entered address
    if ((!candidates || candidates.length === 0) && !selectedCandidate && !selectEnteredAddress) {
        setSelectedAddress(true);
        setSelectedCandidate(enteredAddress);
    }
    function message(text) {
        return (react_1.default.createElement(core_ui_1.Padding, { y: 12 },
            react_1.default.createElement(core_ui_1.MessageBox, { variant: "alert", message: text })));
    }
    return (react_1.default.createElement(core_ui_1.Modal, { isOpen: !!isOpen, onToggle: function () { return handleClose(); }, width: width },
        react_1.default.createElement(core_ui_1.ModalBody, null,
            react_1.default.createElement(core_ui_1.ModalHeader, { titleText: "Verify international address", onClose: function () { return handleClose(); } }),
            react_1.default.createElement(core_ui_1.Padding, { size: 24 },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(core_ui_1.Text, null, "Verification results"),
                    (!candidates || candidates.length === 0) && message('No verification results found for this address'),
                    candidates.length > 0 &&
                        candidates.map(function (candidate) {
                            var formattedCandidateAddress = format_street_address_1.formatCandidateToAddress(candidate);
                            var status = candidate.analysis.verificationStatus;
                            /**
                             * If the candidate is unverified - dont display a SelectableOption.
                             * Display a message and preselect the entered address
                             */
                            if (status === 'None') {
                                if (!selectedCandidate && !selectEnteredAddress) {
                                    setSelectedAddress(true);
                                    setSelectedCandidate(enteredAddress);
                                }
                                return message("This address could not be verified.\n                    If you wish to proceed with your entered address please select it below,\n                    otherwise click Cancel");
                            }
                            return (react_1.default.createElement(selectable_address_1.SelectableAddress, { key: formattedCandidateAddress.formattedAddress, isActive: selectEnteredAddress ||
                                    !candidates ||
                                    (selectedCandidate === null || selectedCandidate === void 0 ? void 0 : selectedCandidate.formattedAddress) === formattedCandidateAddress.formattedAddress, onChange: function () {
                                    var formattedCandidate = format_street_address_1.formatCandidateToAddress(candidate);
                                    setSelectedCandidate(formattedCandidate);
                                }, candidate: candidate }));
                        })),
                react_1.default.createElement(core_ui_1.Text, null, "Entered address"),
                react_1.default.createElement(selectable_address_1.SelectableAddress, { isActive: selectEnteredAddress || (selectedCandidate === null || selectedCandidate === void 0 ? void 0 : selectedCandidate.formattedAddress) === enteredAddress.formattedAddress, onChange: function () { return setSelectedCandidate(enteredAddress); }, enteredAddress: enteredAddress })),
            react_1.default.createElement(core_ui_1.ModalFooter, null,
                react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", justifyContent: "flex-end" },
                    react_1.default.createElement(core_ui_1.Button, { type: "button", size: "secondary", onClick: function () { return handleClose(); } }, "Cancel"),
                    react_1.default.createElement(core_ui_1.Spacing, { width: 12 }),
                    react_1.default.createElement(core_ui_1.Button, { type: "submit", disabled: !selectedCandidate, onClick: function () { return onSelectAddress(selectedCandidate); } }, "Select address"))))));
}
exports.VerifyInternationalAddressModal = VerifyInternationalAddressModal;
